export default __webpack_public_path__ + "static/media/about_hero.670a0bc4.jpg";